// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../styles/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base Button Styles */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-sm);
  font-family: var(--font-family);
  font-weight: var(--font-weight-semibold);
  border: none;
  border-radius: var(--radius-lg);
  cursor: pointer;
  transition: all var(--transition-base);
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  text-decoration: none;
  /* Better mobile touch targets */
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  /* Prevent text selection on double tap */
  user-select: none;
  -webkit-user-select: none;
}
/* Hover effects only on devices with a real pointer, so a tap on a
   touch screen does not leave the element stuck in its hover state. */
@media (hover: hover) {
  .btn:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-md);
  }
}


.btn:active {
  transform: translateY(0);
}

.btn:disabled,
.btn-disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none !important;
}

/* Button Sizes */
.btn-sm {
  padding: var(--space-sm) var(--space-md);
  font-size: var(--font-size-sm);
  border-radius: var(--radius-md);
  min-height: 36px;
}

.btn-md {
  padding: var(--space-md) var(--space-lg);
  font-size: var(--font-size-base);
  min-height: 44px;
}

.btn-lg {
  padding: var(--space-lg) var(--space-xl);
  font-size: var(--font-size-lg);
  min-height: 52px;
}

/* Button Variants */
.btn-primary {
  background: var(--gradient-primary);
  color: var(--color-white);
  box-shadow: var(--shadow-sm);
}
/* Hover effects only on devices with a real pointer, so a tap on a
   touch screen does not leave the element stuck in its hover state. */
@media (hover: hover) {
  .btn-primary:hover {
    box-shadow: var(--shadow-glow);
  }
}


.btn-secondary {
  background: var(--glass-bg-strong);
  color: var(--color-white);
  border: 2px solid var(--glass-border-strong);
  backdrop-filter: blur(10px);
}
/* Hover effects only on devices with a real pointer, so a tap on a
   touch screen does not leave the element stuck in its hover state. */
@media (hover: hover) {
  .btn-secondary:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.5);
  }
}


.btn-success {
  background: var(--color-success);
  color: var(--color-white);
  box-shadow: var(--shadow-sm);
}
/* Hover effects only on devices with a real pointer, so a tap on a
   touch screen does not leave the element stuck in its hover state. */
@media (hover: hover) {
  .btn-success:hover {
    background: var(--color-success-light);
    box-shadow: 0 0 20px rgba(76, 175, 80, 0.4);
  }
}


.btn-danger {
  background: var(--color-error);
  color: var(--color-white);
  box-shadow: var(--shadow-sm);
}
/* Hover effects only on devices with a real pointer, so a tap on a
   touch screen does not leave the element stuck in its hover state. */
@media (hover: hover) {
  .btn-danger:hover {
    background: var(--color-error-light);
    box-shadow: 0 0 20px rgba(239, 68, 68, 0.4);
  }
}


.btn-warning {
  background: var(--color-warning);
  color: var(--color-white);
  box-shadow: var(--shadow-sm);
}
/* Hover effects only on devices with a real pointer, so a tap on a
   touch screen does not leave the element stuck in its hover state. */
@media (hover: hover) {
  .btn-warning:hover {
    background: var(--color-warning-light);
    box-shadow: 0 0 20px rgba(255, 152, 0, 0.4);
  }
}


.btn-ghost {
  background: transparent;
  color: var(--color-white);
  border: 2px solid transparent;
}
/* Hover effects only on devices with a real pointer, so a tap on a
   touch screen does not leave the element stuck in its hover state. */
@media (hover: hover) {
  .btn-ghost:hover {
    background: var(--glass-bg);
    border-color: var(--glass-border);
    transform: none;
    box-shadow: none;
  }
}


.btn-link {
  background: transparent;
  color: var(--color-accent);
  padding: 0;
  border: none;
  min-height: auto;
}
/* Hover effects only on devices with a real pointer, so a tap on a
   touch screen does not leave the element stuck in its hover state. */
@media (hover: hover) {
  .btn-link:hover {
    color: var(--color-accent-light);
    text-decoration: underline;
    transform: none;
    box-shadow: none;
  }
}


/* Button Width */
.btn-full-width {
  width: 100%;
}

/* Loading State */
.btn-loading {
  pointer-events: none;
}

.btn-loading .btn-content {
  opacity: 0;
}

.btn-loader {
  position: absolute;
  width: 16px;
  height: 16px;
  border: 2px solid var(--color-white);
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

.btn-sm .btn-loader {
  width: 12px;
  height: 12px;
}

.btn-lg .btn-loader {
  width: 20px;
  height: 20px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Icon Spacing */
.btn-icon {
  display: inline-flex;
  align-items: center;
  font-size: 1.2em;
}

.btn-icon-left {
  margin-right: calc(var(--space-sm) * -0.5);
}

.btn-icon-right {
  margin-left: calc(var(--space-sm) * -0.5);
}

/* Ripple Effect */
.btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.btn:active::before {
  width: 300px;
  height: 300px;
}

.btn:disabled::before,
.btn-disabled::before {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/Button.css"],"names":[],"mappings":"AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,+BAA+B;EAC/B,wCAAwC;EACxC,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;EAChC,0BAA0B;EAC1B,wCAAwC;EACxC,yCAAyC;EACzC,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;sEACsE;AACtE;EACE;IACE,2BAA2B;IAC3B,4BAA4B;EAC9B;AACF;;;AAGA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,wCAAwC;EACxC,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,mCAAmC;EACnC,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;sEACsE;AACtE;EACE;IACE,8BAA8B;EAChC;AACF;;;AAGA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,4CAA4C;EAC5C,2BAA2B;AAC7B;AACA;sEACsE;AACtE;EACE;IACE,oCAAoC;IACpC,sCAAsC;EACxC;AACF;;;AAGA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;sEACsE;AACtE;EACE;IACE,sCAAsC;IACtC,2CAA2C;EAC7C;AACF;;;AAGA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;sEACsE;AACtE;EACE;IACE,oCAAoC;IACpC,2CAA2C;EAC7C;AACF;;;AAGA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;sEACsE;AACtE;EACE;IACE,sCAAsC;IACtC,2CAA2C;EAC7C;AACF;;;AAGA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;sEACsE;AACtE;EACE;IACE,2BAA2B;IAC3B,iCAAiC;IACjC,eAAe;IACf,gBAAgB;EAClB;AACF;;;AAGA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;AACA;sEACsE;AACtE;EACE;IACE,gCAAgC;IAChC,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;EAClB;AACF;;;AAGA,iBAAiB;AACjB;EACE,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf","sourcesContent":["@import '../../styles/variables.css';\n\n/* Base Button Styles */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-sm);\n  font-family: var(--font-family);\n  font-weight: var(--font-weight-semibold);\n  border: none;\n  border-radius: var(--radius-lg);\n  cursor: pointer;\n  transition: all var(--transition-base);\n  position: relative;\n  overflow: hidden;\n  white-space: nowrap;\n  text-decoration: none;\n  /* Better mobile touch targets */\n  touch-action: manipulation;\n  -webkit-tap-highlight-color: transparent;\n  /* Prevent text selection on double tap */\n  user-select: none;\n  -webkit-user-select: none;\n}\n/* Hover effects only on devices with a real pointer, so a tap on a\n   touch screen does not leave the element stuck in its hover state. */\n@media (hover: hover) {\n  .btn:hover {\n    transform: translateY(-2px);\n    box-shadow: var(--shadow-md);\n  }\n}\n\n\n.btn:active {\n  transform: translateY(0);\n}\n\n.btn:disabled,\n.btn-disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none !important;\n}\n\n/* Button Sizes */\n.btn-sm {\n  padding: var(--space-sm) var(--space-md);\n  font-size: var(--font-size-sm);\n  border-radius: var(--radius-md);\n  min-height: 36px;\n}\n\n.btn-md {\n  padding: var(--space-md) var(--space-lg);\n  font-size: var(--font-size-base);\n  min-height: 44px;\n}\n\n.btn-lg {\n  padding: var(--space-lg) var(--space-xl);\n  font-size: var(--font-size-lg);\n  min-height: 52px;\n}\n\n/* Button Variants */\n.btn-primary {\n  background: var(--gradient-primary);\n  color: var(--color-white);\n  box-shadow: var(--shadow-sm);\n}\n/* Hover effects only on devices with a real pointer, so a tap on a\n   touch screen does not leave the element stuck in its hover state. */\n@media (hover: hover) {\n  .btn-primary:hover {\n    box-shadow: var(--shadow-glow);\n  }\n}\n\n\n.btn-secondary {\n  background: var(--glass-bg-strong);\n  color: var(--color-white);\n  border: 2px solid var(--glass-border-strong);\n  backdrop-filter: blur(10px);\n}\n/* Hover effects only on devices with a real pointer, so a tap on a\n   touch screen does not leave the element stuck in its hover state. */\n@media (hover: hover) {\n  .btn-secondary:hover {\n    background: rgba(255, 255, 255, 0.2);\n    border-color: rgba(255, 255, 255, 0.5);\n  }\n}\n\n\n.btn-success {\n  background: var(--color-success);\n  color: var(--color-white);\n  box-shadow: var(--shadow-sm);\n}\n/* Hover effects only on devices with a real pointer, so a tap on a\n   touch screen does not leave the element stuck in its hover state. */\n@media (hover: hover) {\n  .btn-success:hover {\n    background: var(--color-success-light);\n    box-shadow: 0 0 20px rgba(76, 175, 80, 0.4);\n  }\n}\n\n\n.btn-danger {\n  background: var(--color-error);\n  color: var(--color-white);\n  box-shadow: var(--shadow-sm);\n}\n/* Hover effects only on devices with a real pointer, so a tap on a\n   touch screen does not leave the element stuck in its hover state. */\n@media (hover: hover) {\n  .btn-danger:hover {\n    background: var(--color-error-light);\n    box-shadow: 0 0 20px rgba(239, 68, 68, 0.4);\n  }\n}\n\n\n.btn-warning {\n  background: var(--color-warning);\n  color: var(--color-white);\n  box-shadow: var(--shadow-sm);\n}\n/* Hover effects only on devices with a real pointer, so a tap on a\n   touch screen does not leave the element stuck in its hover state. */\n@media (hover: hover) {\n  .btn-warning:hover {\n    background: var(--color-warning-light);\n    box-shadow: 0 0 20px rgba(255, 152, 0, 0.4);\n  }\n}\n\n\n.btn-ghost {\n  background: transparent;\n  color: var(--color-white);\n  border: 2px solid transparent;\n}\n/* Hover effects only on devices with a real pointer, so a tap on a\n   touch screen does not leave the element stuck in its hover state. */\n@media (hover: hover) {\n  .btn-ghost:hover {\n    background: var(--glass-bg);\n    border-color: var(--glass-border);\n    transform: none;\n    box-shadow: none;\n  }\n}\n\n\n.btn-link {\n  background: transparent;\n  color: var(--color-accent);\n  padding: 0;\n  border: none;\n  min-height: auto;\n}\n/* Hover effects only on devices with a real pointer, so a tap on a\n   touch screen does not leave the element stuck in its hover state. */\n@media (hover: hover) {\n  .btn-link:hover {\n    color: var(--color-accent-light);\n    text-decoration: underline;\n    transform: none;\n    box-shadow: none;\n  }\n}\n\n\n/* Button Width */\n.btn-full-width {\n  width: 100%;\n}\n\n/* Loading State */\n.btn-loading {\n  pointer-events: none;\n}\n\n.btn-loading .btn-content {\n  opacity: 0;\n}\n\n.btn-loader {\n  position: absolute;\n  width: 16px;\n  height: 16px;\n  border: 2px solid var(--color-white);\n  border-top-color: transparent;\n  border-radius: 50%;\n  animation: spin 0.6s linear infinite;\n}\n\n.btn-sm .btn-loader {\n  width: 12px;\n  height: 12px;\n}\n\n.btn-lg .btn-loader {\n  width: 20px;\n  height: 20px;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Icon Spacing */\n.btn-icon {\n  display: inline-flex;\n  align-items: center;\n  font-size: 1.2em;\n}\n\n.btn-icon-left {\n  margin-right: calc(var(--space-sm) * -0.5);\n}\n\n.btn-icon-right {\n  margin-left: calc(var(--space-sm) * -0.5);\n}\n\n/* Ripple Effect */\n.btn::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 0;\n  height: 0;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.3);\n  transform: translate(-50%, -50%);\n  transition: width 0.6s, height 0.6s;\n}\n\n.btn:active::before {\n  width: 300px;\n  height: 300px;\n}\n\n.btn:disabled::before,\n.btn-disabled::before {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
